import moment from 'moment/moment.js'
class TimeHelper {
  constructor () {
    this.moment = moment
    require('moment/locale/he')
  }

  getDate (date_string) {
    if (date_string.length > 0) {
      return new Date(date_string)
    }
    return new Date()
  }

  getTimeInput (date_string, include_seconds) {
    let date = new Date(date_string)
    let minutes = this.makeTwoChars(date.getMinutes())
    let hours = this.makeTwoChars(date.getHours())
    let time = hours + ':' + minutes
    if (include_seconds) {
      time += ':' + this.makeTwoChars(date.getSeconds())
    }
    return time
  }

  getMonthsInHebrew () {
    return ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר']
  }

  getDayOfWeekInHebrew () {
    return ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת']
  }

  getDayOfWeek () {
    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  }

  getDateInput (date_string) {
    let date = new Date(date_string)
    let month = this.makeTwoChars(date.getMonth() + 1)
    let day = this.makeTwoChars(date.getDate())
    return date.getFullYear() + '-' + month + '-' + day
  }

  makeTwoChars (my_object) {
    let as_string = my_object.toString()
    if (as_string.length == 1) {
      return '0' + as_string
    }
    return as_string
  }

  getDateInMoreDays (days) {
    let current_date = this.getCurrentDate()
    return new Date(
      current_date.getFullYear(),
      current_date.getMonth(),
      current_date.getDate() + days
    )
  }

  getToday () {
    let date = this.getCurrentDate()
    date.setHours(0, 0, 0, 0)
    return date
  }

  getYesterday () {
    let date = this.getCurrentDate()
    date.setDate(date.getDate() - 1)
    return date
  }

  getTomorrow () {
    let date = this.getCurrentDate()
    date.setDate(date.getDate() + 1)
    return date
  }

  getLastWeek () {
    let date = this.getCurrentDate()
    date.setDate(date.getDate() - 7)
    return date
  }

  getNextWeek () {
    let date = this.getCurrentDate()
    date.setDate(date.getDate() + 7)
    return date
  }

  getLastMonth () {
    let date = this.getCurrentDate()
    date.setMonth(date.getMonth() - 1)
    return date
  }

  getCurrentDate () {
    return new Date()
  }

  setDate (value) {
    var date = new Date(value)
    if (this.validDate(date)) {
      return date
    }
    return false
  }

  setTime (date, value) {
    let next_contact_time = value.split(':')
    if (next_contact_time.length > 1) {
      date.setHours(next_contact_time[0] * 1)
      date.setMinutes(next_contact_time[1] * 1)
      return date
    }
    date.setHours(0, 0, 0)
    return date
  }

  validDate (d) {
    // https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
    if (Object.prototype.toString.call(d) === '[object Date]') {
      // it is a date object
      if (isNaN(d.getTime())) {
        // d.valueOf() could also work
        return false
      }
      return true
    }
    return false
  }

  makeTimeReadable (time) {
    let m = moment(new Date(time))
    return time == 'null' ? '' : m.calendar()
  }

  getTimeDifference (start_date, end_date) {
    return moment.duration(moment(end_date).diff(moment(start_date)))
  }

  getDaysInMonth (month) {
    let date = new Date()
    date.setMonth(month)
    return moment(date).daysInMonth()
  }

  convertDecimalHoursToTime (decimal_hours) {
    // https://stackoverflow.com/questions/35460303/how-to-convert-decimal-hour-value-to-hhmmss/35460620
    let date = new Date(0, 0)
    date.setSeconds(decimal_hours * 60 * 60)
    return this.getTimeInput(date, true)
  }
}

export default TimeHelper
